import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Header from './Header';
import ChatWidget from '../ChatWidget';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${props => props.theme.colors.background};

  @media print {
    display: block !important;
    background-color: white !important;
  }
`;

const MainContent = styled.div`
  flex: 1;
  margin-left: 260px;
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    margin-left: 0;
  }

  @media print {
    margin-left: 0 !important;
    display: block !important;
  }
`;

const ContentArea = styled.main`
  flex: 1;
  padding: ${props => props.theme.spacing.xl};
  overflow-y: auto;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    padding: ${props => props.theme.spacing.md};
  }

  @media print {
    padding: 0 !important;
    overflow: visible !important;
  }
`;

const HeaderWrapper = styled.div`
  @media print { display: none !important; }
`;

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <MainContent>
        <HeaderWrapper>
          <Header onMenuToggle={() => setSidebarOpen(o => !o)} />
        </HeaderWrapper>
        <ContentArea>
          {children}
        </ContentArea>
      </MainContent>
      <ChatWidget />
    </LayoutContainer>
  );
};

export default Layout;
